(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/gameguide/assets/javascripts/game-guide-article.js') >= 0) return;  svs.modules.push('/components/components/gameguide/assets/javascripts/game-guide-article.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.components.gameguide.GameGuideArticle = Marionette.View.extend({
    tagName: 'article',
    className: 'padding-1',
    template(data) {
      return svs.components.gameguide.templates.game_guide_article(data);
    },
    templateContext() {
      const article = this.model;
      article.set('title', undefined);
      return {
        article
      };
    }
  });
})(Backbone, _, svs);

 })(window);